import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { allRoutesQuery } from "./allRoutesQuery";
import type { Route } from "./fragments/gql/Route";
import type { QueryResult } from "./types/QueryResult";

export const useAllRoutes = (options?: {
  skip?: boolean;
  includeClosedRoutes?: boolean;
}): QueryResult<Route[]> => {
  const { data, loading, error } = useQuery(allRoutesQuery, {
    skip: options?.skip,
  });

  const routes = useMemo(
    () =>
      (data?.viewer.routes.allRoutes2 ?? []).filter(
        (r) => options?.includeClosedRoutes || !r.isClosed,
      ),
    [data?.viewer.routes.allRoutes2, options?.includeClosedRoutes],
  );

  return [routes, loading, error];
};
